import React from "react";
import { Link } from "react-router-dom";
import { FaCoins, FaUserFriends, FaChartLine } from "react-icons/fa";
import logoBanner from "../assets/images/new_logo_without_font.png";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Header */}
      <header className="border-b border-gray-800 px-6 py-4 flex items-center justify-between">
        <Link to="/index">
		<img src={logoBanner} alt="CoinZUp Logo" className="w-40 h-auto" />
		</Link>
        <div className="space-x-4">
          <Link to="/login" className="text-sm hover:underline">Log In</Link>
          <Link to="/register" className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition">Sign Up</Link>
        </div>
      </header>
		      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 border-b border-gray-700 pb-2">Legal Notice & Privacy Policy</h1>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Site Owner</h2>
          <p className="text-gray-300">
            Website: <strong>CoinZUp</strong><br />
                       Status: Private individual (non-professional)<br />
            Contact: <a href="mailto:contact@coinzup.com" className="text-yellow-400">contact@coinzup.com</a>
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Hosting Provider</h2>
          <p className="text-gray-300">
            Host: OVH <br />
            Website: <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer" className="text-yellow-400">https://www.ovh.com</a><br />
    
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
          <p className="text-gray-300">
            All elements of this website (texts, images, graphics, logos, icons, etc.) are the property of the owner, unless otherwise stated. Any reproduction or redistribution without prior permission is strictly forbidden.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">Personal Data</h2>
          <p className="text-gray-300">
            No personal data is collected without your knowledge. If you create an account, your email and data are stored securely and will never be shared with third parties without your consent.
            In accordance with the GDPR, you have the right to access, rectify, or delete your data. To exercise this right, contact us at: <a href="mailto:contact@coinzup.com" className="text-yellow-400">contact@coinzup.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">Cookies</h2>
          <p className="text-gray-300">
            This website may use cookies to enhance user experience. You can refuse cookies by adjusting your browser settings.
          </p>
        </section>
      </div>

      {/* Footer */}
           <footer className="bg-gray-900/80 text-center text-sm text-gray-500 py-4 border-t border-gray-800">
        © 2025 CoinzUp.net. All rights reserved. &nbsp;
        <Link to="/notice" className="hover:text-white underline">Privacy & Legal Notice</Link>
		<Link to="/terms" className="hover:text-white underline">Terms & Conditions</Link>
      </footer>
    </div>
  );
}
